<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Ações do Controle de Acesso</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Ações</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table v-if="!loadingList" class="table mb-0">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0 text-left">Descrição</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(action, index) in Actions" :key="index">
                    <td></td>
                    <td class="text-left">{{ action.Name }}</td>
                    <td class="text-left">{{ action.Description }}</td>
                    <td></td>
                    <td></td>

                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('AccessAction', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMAction($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('AccessAction', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMAction($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('AccessAction', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ProcessDelete(action.Name, action.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      action_list == undefined ||
                      action_list == null ||
                      action_list.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="sm"
      id="mFormAction"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <ValidationObserver tag="form" ref="ActionValidationForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label for="inputApiName">Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  v-if="isSeeing"
                  v-bind:value="action.Name"
                  type="text"
                  id="inputApiName"
                  disabled
                />
                <d-form-input
                  v-else
                  v-model="action.Name"
                  :class="validatedActionForm | showValidateError(invalid)"
                  type="text"
                  id="inputApiName"
                  placeholder="Nome"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedActionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="12" class="form-group">
              <label for="textDescription">Descrição</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <b-form-textarea
                  v-if="isSeeing"
                  v-bind:value="action.Description"
                  id="textDescription"
                  disabled
                />
                <b-form-textarea
                  v-else
                  v-model="action.Description"
                  :class="validatedActionForm | showValidateError(invalid)"
                  id="textDescription"
                  placeholder="Descrição"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedActionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="CreateOrUpdate()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('AccessAction', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova ação"
      v-on:click="OpenMAction($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "access-actions",
  data: function () {
    return {
      modalTitle: "Nova Ação",
      labelName: "Nome",
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      countFilter: 0,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Name: null,
      },
      action_list: [],
      pOpened: null,
      action: {
        Name: null,
        Description: null,
      },
      isSeeing: false,
      validatedActionForm: false,
    };
  },
  computed: {
    Actions() {
      return this.action_list;
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListAccessAction();
    },
    "pagination.RowsPerPage": function () {
      this.ListAccessAction();
    },
  },
  mounted() {
    this.ListAccessAction();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListAccessAction();
    },
    ListAccessAction: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListAccessAction", { params: data })
        .then((response) => {
          this.action_list = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar a lista de ações",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
      };
      this.ListAccessAction();
    },
    OpenMAction: function (e, i, view) {
      this.validatedActionForm = false;
      this.loadingAddUpdate = false;
      e.preventDefault();

      this.ResetActionInfo();
      if (view == undefined && i != undefined) {
        // Edit
        this.modalTitle = "Editar ação";
        this.pOpened = i;

        let actionId = this.action_list[i].Id;
        this.GetAction(actionId);

        this.isSeeing = false;
      } else if (view == undefined && i == undefined) {
        // Add new
        this.modalTitle = "Nova ação";
        this.pOpened = null;
        this.isSeeing = false;
        this.ResetActionInfo();
      } else {
        // View
        this.modalTitle = "Detalhes do módulo";
        this.pOpened = i;

        let actionId = this.action_list[i].Id;
        this.GetAction(actionId);

        this.isSeeing = true;
      }

      this.$bvModal.show("mFormAction");
    },
    ResetActionInfo: function () {
      this.action = {
        Name: null,
        Description: null,
      };
    },
    CreateOrUpdate: function () {
      this.validatedActionForm = true;

      this.$refs.ActionValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (this.pOpened == null) {
            // Add
            this.AddAction();
          } else {
            // Update
            this.UpdateAction();
          }
        }
      });
    },
    AddAction: function () {
      this.$store
        .dispatch("AddAccessAction", { action: this.action })
        .then(() => {
          this.$makeToast(
            "A ação foi cadastrada com sucesso.",
            "success",
            "Ação cadastrada"
          );
          this.ListAccessAction();
          this.$bvModal.hide("mFormAction");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao cadastrar a ação",
            error
          );
        })
        .finally(() => {
          this.loadingAddUpdate = false;
          this.isSeeing = false;
        });
    },
    GetAction: function (actionId) {
      this.loadingModal = true;
      this.$store
        .dispatch("GetAccessAction", { id: actionId })
        .then((response) => {
          this.action = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar a ação",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    UpdateAction: function () {
      this.$store
        .dispatch("UpdateAccessAction", { action: this.action })
        .then(() => {
          this.$makeToast(
            "A ação foi atualizada com sucesso.",
            "success",
            "Ação atualizada"
          );
          this.ListAccessAction();
          this.$bvModal.hide("mFormAction");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar a ação",
            error
          );
        })
        .finally(() => {
          this.isSeeing = false;
          this.loadingAddUpdate = false;
        });
    },
    ProcessDelete: function (actionName, actionId) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover " + actionName + "?",
        "Confirmar",
        this.DeleteAction,
        actionId
      );
    },
    DeleteAction: function (actionId) {
      this.$store
        .dispatch("DeleteAccessAction", { id: actionId })
        .then(() => {
          this.$makeToast(
            "A ação foi removida com sucesso.",
            "success",
            "Ação removida"
          );
          this.ListAccessAction();
          this.$bvModal.hide("mFormAction");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao remover a ação", error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/accessActions.vue